<template>
  <header class="fixed h-20 top-0 bg-white w-screen lg:w-full z-40">
    <transition name="fade">
      <div
        class="py-2 px-1 md:px-12 h-20 flex justify-between items-center absolute top-0 left-0 w-full"
      >
        <div class="h-full sm:px-4 flex items-center">
          <a
            class="h-full py-2 sm:py-0"
            href="http://rotachrom.com"
            target="_blank"
          >
            <img
              alt="rotaChrom-logo"
              class="h-full w-auto"
              src="../assets/img/rc-logo-full.png"
            />
          </a>

          <img
            class="h-cross w-cross md:mx-2 p-1 md:p-0"
            src="../assets/img/x.png"
            alt="x"
          />

          <a
            class="h-full py-2 sm:py-0"
            href="https://heidolph-instruments.com/"
            target="_blank"
          >
            <img
              alt="hbx-logo"
              class="h-full w-auto"
              src="../assets/img/heidolph-logo-full.png"
            />
          </a>
        </div>
        <div class="flex lg:hidden items-center h-full ml-auto mr-1">
          <div
            id="nav-btn"
            class="flex items-center cursor-pointer focus:outline-none"
          >
            <button
              id="hamburger"
              class="hamburger hamburger--squeeze focus:outline-none"
              type="button"
            >
              <span class="hamburger-box">
                <span class="hamburger-inner bg-h-orange"></span>
              </span>
            </button>
          </div>
        </div>
        <transition name="fadeDown">
          <div
            id="mobile-nav"
            class="absolute w-full top-0 mt-16 right-0 bg-white hidden flex lg:hidden flex-col items-center shadow-md"
          >
            <a
              class="px-4 hover:text-h-orange text-2xl border-gray-300 w-full text-center border hover:border-h-orange px-8 py-4 ease-in-out duration-200 transition-colors"
              href="/"
              >Home</a
            >
            <a
              class="px-4 hover:text-h-orange text-2xl border-gray-300 w-full text-center border hover:border-h-orange px-8 py-4 ease-in-out duration-200 transition-colors"
              href="#"
              v-scroll-to="'#rotaChrom'"
              >Product & Services</a
            >
            <!-- <a
              class="px-4 hover:text-h-orange text-2xl border-gray-300 w-full text-center border hover:border-h-orange px-8 py-4 ease-in-out duration-200 transition-colors"
              href="/#exhibitions"
              >Exhibitons</a
            > -->
            <a
              class="px-4 hover:text-h-orange text-2xl border-gray-300 w-full text-center border hover:border-h-orange px-8 py-4 ease-in-out duration-200 transition-colors"
              href="#"
              v-scroll-to="'#contact'"
              >Contact Us</a
            >
          </div>
        </transition>
        <div class="hidden lg:flex">
          <a
            class="px-4 hover:text-h-orange ease-in-out duration-200 transition-colors"
            href="/"
            >Home</a
          >
          <a
            class="px-4 hover:text-h-orange ease-in-out duration-200 transition-colors"
            href="#"
            v-scroll-to="'#rotaChrom'"
            >Product & Services</a
          >
          <!-- <a
            class="px-4 hover:text-h-orange ease-in-out duration-200 transition-colors"
            href="/#exhibitions"
            >Exhibitons</a
          > -->
          <a
            class="px-4 hover:text-h-orange ease-in-out duration-200 transition-colors"
            href="#"
            v-scroll-to="'#contact'"
            >Contact Us</a
          >
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
export default {
  name: "RoHHeader",
  props: {},

  components: {},
};
</script>

<style scoped></style>
